<template>
  <div class="tile is-parent is-vertical"
    style="max-width:100vvw">
    <!-- <article v-if="quotes"
      class="tile is-child box detail-page-tile has-sticky-tile"> -->
    <orm-batch-statistics v-model="value"
      :quotes="combinedBatchedQuotes"
      :count="combinedBatchedQuotes ? combinedBatchedQuotes.length : 0"
      :alr="alr"
      :adjusted-alr="adjustedCombinedAlr"
      :alr-lower-threshold="innerValue.alrLowerThreshold"
      :alr-upper-threshold="innerValue.alrUpperThreshold"
      :average-total-ex-gst="averageTotalExGst"
      :adjusted-total="adjustedTotal"
      :is-can-edit="isCanEdit" />
    <!-- </article> -->

    <article class="tile is-child box setting-page-tile"
      style="overflow-x: auto;">
      <div>
        <div class="columns is-mobile is-justify-content-space-between">

          <div class="column is-narrow">
            <!-- Left group -->
            <div class="columns">
              <div class="column">
                <div class="field is-horizontal">
                  <div class="field-label is-narrow is-flex is-align-items-center is-justify-content-center">
                    <label class="label has-text-nowrap">Total Val (ex GST)</label>
                  </div>
                  <div class="field-body">
                    <div class="field is-narrow">
                      <p class="control">
                        <vue-numeric class="input has-text-right custom-setting"
                          v-model="innerValue.perQuoteTotalMin"
                          :min="0"
                          symbol="$"
                          :precision="2"
                          :disabled="!isBatchCanEdit" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field is-horizontal">
                  <div class="field-label is-narrow is-flex is-align-items-center is-justify-content-center">
                    <label class="label has-text-nowrap">to</label>
                  </div>
                  <div class="field-body">
                    <div class="field is-narrow">
                      <p class="control">
                        <vue-numeric class="input has-text-right custom-setting"
                          v-model="innerValue.perQuoteTotalMax"
                          :min="0"
                          symbol="$"
                          :precision="2"
                          :disabled="!isBatchCanEdit" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-narrow">
            <!-- Center group -->
            <div class="columns">
              <div class="column is-narrow">
                <div class="field is-horizontal">
                  <div class="field-label is-narrow is-flex is-align-items-center is-justify-content-center">
                    <label class="label has-text-nowrap">Avg Target Cost</label>
                  </div>
                  <div class="field-body">
                    <div class="field is-narrow">
                      <p class="control">
                        <vue-numeric class="input has-text-right custom-setting"
                          v-model="innerValue.agreedArc"
                          :min="0"
                          symbol="$"
                          :precision="2"
                          :disabled="!isBatchCanEdit" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="column is-narrow">
            <!-- Right group -->
            <div class="columns">
              <div class="column">
                <div class="field is-horizontal">
                  <div class="field-label is-narrow is-flex is-align-items-center is-justify-content-center">
                    <label class="label has-text-nowrap">ALR L. Threshold</label>
                  </div>
                  <div class="field-body">
                    <div class="field is-narrow">
                      <p class="control">
                        <vue-numeric class="input has-text-right custom-setting"
                          v-model="innerValue.alrLowerThreshold"
                          :min="0"
                          symbol="$"
                          :precision="2"
                          :disabled="!isBatchCanEdit" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column">
                <div class="field is-horizontal">
                  <div class="field-label is-narrow is-flex is-align-items-center is-justify-content-center">
                    <label class="label has-text-nowrap">ALR U. Threshold</label>
                  </div>
                  <div class="field-body">
                    <div class="field is-narrow">
                      <p class="control">
                        <vue-numeric class="input has-text-right custom-setting"
                          v-model="innerValue.alrUpperThreshold"
                          :min="0"
                          symbol="$"
                          :precision="2"
                          :disabled="!isBatchCanEdit" />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>

    <article class="tile is-child box detail-page-tile">
      <div class="columns">
        <div class="column">
          <p class="title">
            <span class="section-heading">
              <span class="section-heading-color pr-1">In Batch</span>
              <span class="has-text-primary">({{ batchedQuotesTotalRows }})</span>
            </span>
          </p>
        </div>
        <div v-if="isBatchCanEdit"
          class="column is-narrow">
          <div class="field is-narrow">
            <button class="button tooltip ml-5 button-remove"
              data-tooltip="Remove Selected from Batch"
              :disabled="!batchedQuotes.length"
              @click="removeRangeToBatch">
              <!-- <span class="icon">
                <i class="mdi mdi-minus mdi-24px" />
              </span> -->
              Remove from Batch
            </button>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="field is-narrow has-addons">
            <div class="control has-icons-left">
              <input class="input"
                v-model="batchedQuotesQuery"
                type="text"
                placeholder="Quote No. or Rego">
              <span class="icon is-left">
                <i class="mdi mdi-magnify mdi-24px" />
              </span>
            </div>
            <div class="control">
              <a class="button is-primary is-outlined tooltip"
                data-tooltip="Reset search"
                @click="batchedQuotesQuery = ''">
                <span class="icon">
                  <i class="mdi mdi-close mdi-24px" />
                </span>
              </a>
            </div>
          </div>
        </div>
        <div class="column is-narrow pl-0">
          <button class="button tooltip is-success"
            data-tooltip="Download Excel"
            :disabled="!batchedQuotes.length"
            @click="exportToExcel(tableType.INBATCH)">
            <span class="icon">
              <i class="mdi mdi-file-download-outline  mdi-24px" />
            </span>
          </button>
        </div>
      </div>
      <div class="field">
        <div class="table-container">
          <bulma-table class="table is-striped is-narrow is-fullwidth is-hoverable"
            ref="batchedQuotesTable"
            :columns="batchingQuoteColumns"
            :page-index="batchedQuotesFilter.pageIndex"
            :page-size="batchedQuotesFilter.pageSize"
            :total-rows="batchedQuotesTotalRows"
            :is-loading="isBatchedQuotesTableLoading"
            :sort-column="batchedQuotesFilter.sortColumn"
            :sort-order="batchedQuotesFilter.sortOrder"
            :draggable="false"
            :show-pagination="false"
            @sort="onBatchedQuotesSort"
            :is-title-checkable="isBatchCanEdit"
            :title-checkbox-location="'front'"
            @title-checkbox-changed="batchedCheckboxChanged">
            <tr v-for="(quote, index) in filteredBatchedQuotes"
              :key="quote.quoteId"
              @click="highlightSelectedAvailableQuote(index, $event)">
              <td v-if="isBatchCanEdit"
                class="has-vertical-middle has-text-centered">
                <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                  <input v-model="quote.isChecked"
                    @change="handleBatchedCheckboxChange"
                    type="checkbox">
                  <div class="state p-info">
                    <i class="icon mdi mdi-check" />
                    <label />
                  </div>
                </div>
              </td>
              <td>
                <a href="#"
                  @click="viewQuote(quote.quoteId)">{{ quote.quoteNoRef }}</a>
              </td>
              <td>{{ quote.quoteStatus }}</td>
              <td>{{ quote.jobStage }}</td>
              <td>{{ quote.quoteStatusText }}</td>
              <!-- <td class="has-vertical-middle has-text-centered">
                <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                  <input v-model="quote.hasSeverity"
                    :disabled="true"
                    type="checkbox">
                  <div class="state p-info">
                    <i class="icon mdi mdi-check" />
                    <label />
                  </div>
                </div>
              </td>
              <td class="has-text-right">{{ quote.jobStart | formatDateLocale($userInfo.locale) }}</td> -->
              <td class="has-text-right">{{ quote.jobEnd | formatDateLocale($userInfo.locale) }}</td>
              <td class="has-text-centered">{{ quote.daysElapsed }}</td>
              <td>{{ quote.claimNo }}</td>
              <td>{{ quote.rego }}</td>
              <td>{{ quote.fullName }}</td>
              <td>{{ quote.insurer }}</td>
              <td class="has-text-right">{{ quote.excess | formatCurrency($userInfo.locale) }}</td>

              <td class="has-text-right">{{ quote.labourHour | formatNumberWithRounding($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.rate | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.labourTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.partTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.subletTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.miscTotal | formatCurrency($userInfo.locale) }}</td>
              <!-- <td>{{ quote.insurer }}</td> -->
              <!-- <td class="has-text-right">{{ quote.totalNotInvoiced | formatCurrency($userInfo.locale) }}</td> -->
              <!-- <td class="has-text-right">{{ quote.debtorInvoice | formatCurrency($userInfo.locale) }}</td> -->
              <td class="has-text-right">{{ quote.totalExGST | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right"
                :class="{ 'has-text-danger': delta(quote) < 0, 'has-text-success': delta(quote) >= 0 }">{{ delta(quote) | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-centered col-1">
                <a @mouseover="getNotesContent(quote.isNoteExists, quote.quoteId)"
                  @mouseout="resetNotesContent()"
                  @click="notesClick(quote.quoteId, quote.quoteNoRef)"
                  class="button is-dark is-small is-inverted">
                  <span class="icon is-medium"
                    v-tippy="{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }"
                    :content="notesContent">
                    <i class="mdi mdi-24px"
                      :class="[quote.isNoteExists ? 'mdi-note-edit has-text-warning': 'mdi-note-edit-outline has-text-grey']" />
                  </span>
                </a>
              </td>
              <!-- <td class="has-text-centered">
              <span class="icon"
                :class="[ quote.inScope ? 'has-text-success' : 'has-text-danger' ]">
                <i class="mdi mdi-24px"
                  :class="[ quote.inScope ? 'mdi-check' : 'mdi-close' ]" />
              </span>
            </td> -->
              <!-- <td class="has-vertical-middle has-text-centered is-content-width">
                <button class="button is-success is-small is-inverted tooltip is-tooltip-topright"
                  @click="removeFromBatch(index, [quote])"
                  data-tooltip="Remove from batch">
                  <span class="icon is-medium">
                    <i class="mdi mdi-minus mdi-24px" />
                  </span>
                </button>
              </td> -->
            </tr>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <span icon="icon is-large">
                    <i class="mdi mdi-48px mdi-emoticon-sad" />
                  </span>
                  <p>Nothing</p>
                </div>
              </section>
            </template>
          </bulma-table>
        </div>
      </div>
    </article>

    <article v-if="!isBatchCompleted"
      class="tile is-child box detail-page-tile">
      <div class="columns">
        <div class="column">
          <p class="title">
            <span class="section-heading">
              <span class="section-heading-color pr-1">In Scope - Completed</span>
              <span class="has-text-primary">({{ inScopeQuotesTotalRows }})</span>
            </span>

          </p>
        </div>
        <div v-if="isBatchCanEdit"
          class="column is-narrow">
          <div class="field is-narrow">
            <button class="button tooltip ml-5 button-add"
              data-tooltip="Add Selected to Batch"
              :disabled="!inScopeQuotes.length"
              @click="addRangeToBatch(tableType.INSCOPE)">
              <!-- <span class="icon">
                <i class="mdi mdi-plus mdi-24px" />
              </span> -->
              Add to Batch
            </button>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="field is-narrow has-addons">
            <div class="control has-icons-left">
              <input class="input"
                v-model="inScopeQuotesQuery"
                type="text"
                placeholder="Quote No. or Rego">
              <span class="icon is-left">
                <i class="mdi mdi-magnify mdi-24px" />
              </span>
            </div>
            <div class="control">
              <a class="button is-primary is-outlined tooltip"
                data-tooltip="Reset search"
                @click="inScopeQuotesQuery = ''">
                <span class="icon">
                  <i class="mdi mdi-close mdi-24px" />
                </span>
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="column is-narrow pl-0">
          <button class="button tooltip is-success"
            data-tooltip="Download Excel"
            :disabled="!inScopeQuotes.length"
            @click="exportToExcel(tableType.INSCOPE)">
            <span class="icon">
              <i class="mdi mdi-file-download-outline  mdi-24px" />
            </span>
          </button>
        </div> -->
      </div>
      <div class="field">
        <div class="table-container">
          <bulma-table class="table is-striped is-narrow is-fullwidth"
            ref="inScopeQuotesTable"
            :columns="batchingQuoteColumns"
            :page-index="inScopeQuotesFilter.pageIndex"
            :page-size="inScopeQuotesFilter.pageSize"
            :total-rows="inScopeQuotesTotalRows"
            :is-loading="isInScopeQuotesTableLoading"
            :sort-column="inScopeQuotesFilter.sortColumn"
            :sort-order="inScopeQuotesFilter.sortOrder"
            :draggable="false"
            :show-pagination="false"
            @sort="onInScopeQuotesSort"
            :is-title-checkable="isBatchCanEdit"
            :title-checkbox-location="'front'"
            @title-checkbox-changed="inScopeCheckboxChanged">
            <tr v-for="(quote, index) in filteredInScopeQuotes"
              :key="quote.quoteId"
              @click="highlightSelectedAvailableQuote(index, $event)">
              <td v-if="isBatchCanEdit"
                class="has-vertical-middle has-text-centered">
                <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                  <input v-model="quote.isChecked"
                    @change="handleInScopeCheckboxChange"
                    type="checkbox">
                  <div class="state p-info">
                    <i class="icon mdi mdi-check" />
                    <label />
                  </div>
                </div>
              </td>
              <td>
                <a href="#"
                  @click="viewQuote(quote.quoteId)">{{ quote.quoteNoRef }}</a>
              </td>
              <td>{{ quote.quoteStatus }}</td>
              <td>{{ quote.jobStage }}</td>
              <td>{{ quote.quoteStatusText }}</td>
              <!-- <td class="has-vertical-middle has-text-centered">
                <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                  <input v-model="quote.hasSeverity"
                    :disabled="true"
                    type="checkbox">
                  <div class="state p-info">
                    <i class="icon mdi mdi-check" />
                    <label />
                  </div>
                </div>
              </td>
              <td class="has-text-right">{{ quote.jobStart | formatDateLocale($userInfo.locale) }}</td> -->
              <td class="has-text-right">{{ quote.jobEnd | formatDateLocale($userInfo.locale) }}</td>
              <td class="has-text-centered">{{ quote.daysElapsed }}</td>
              <td>{{ quote.claimNo }}</td>
              <td>{{ quote.rego }}</td>
              <td>{{ quote.fullName }}</td>
              <td>{{ quote.insurer }}</td>
              <td class="has-text-right">{{ quote.excess | formatCurrency($userInfo.locale) }}</td>

              <td class="has-text-right">{{ quote.labourHour | formatNumberWithRounding($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.rate | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.labourTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.partTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.subletTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.miscTotal | formatCurrency($userInfo.locale) }}</td>
              <!-- <td>{{ quote.insurer }}</td> -->
              <!-- <td class="has-text-right">{{ quote.totalNotInvoiced | formatCurrency($userInfo.locale) }}</td> -->
              <!-- <td class="has-text-right">{{ quote.debtorInvoice | formatCurrency($userInfo.locale) }}</td> -->
              <td class="has-text-right">{{ quote.totalExGST | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right"
                :class="{ 'has-text-danger': delta(quote) < 0, 'has-text-success': delta(quote) >= 0 }">{{ delta(quote) | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-centered col-1">
                <a @mouseover="getNotesContent(quote.isNoteExists, quote.quoteId)"
                  @mouseout="resetNotesContent()"
                  @click="notesClick(quote.quoteId, quote.quoteNoRef)"
                  class="button is-dark is-small is-inverted">
                  <span class="icon is-medium"
                    v-tippy="{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }"
                    :content="notesContent">
                    <i class="mdi mdi-24px"
                      :class="[quote.isNoteExists ? 'mdi-note-edit has-text-warning': 'mdi-note-edit-outline has-text-grey']" />
                  </span>
                </a>
              </td>
              <!-- <td class="has-text-centered">
              <span class="icon"
                :class="[ quote.inScope ? 'has-text-success' : 'has-text-danger' ]">
                <i class="mdi mdi-24px"
                  :class="[ quote.inScope ? 'mdi-check' : 'mdi-close' ]" />
              </span>
            </td> -->
              <!-- <td class="has-text-centered is-content-width">
                <button class="button is-success is-small is-inverted tooltip is-tooltip-topright"
                  @click="addToBatch(index, [quote])"
                  data-tooltip="Add to batch">
                  <span class="icon is-medium">
                    <i class="mdi mdi-plus mdi-24px" />
                  </span>
                </button>
              </td> -->
            </tr>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <span icon="icon is-large">
                    <i class="mdi mdi-48px mdi-emoticon-sad" />
                  </span>
                  <p>Nothing</p>
                </div>
              </section>
            </template>
          </bulma-table>
        </div>
      </div>
    </article>

    <article v-if="!isBatchCompleted"
      class="tile is-child box detail-page-tile">
      <div class="columns">
        <div class="column">
          <p class="title">
            <span class="section-heading">
              <span class="section-heading-color pr-1">In Scope - In Progress</span>
              <span class="has-text-primary mr-3">({{ inProgressQuotesTotalRows }})</span>
              <span class="section-heading-color">{{ inProgressQuotesAvgCost | formatCurrency($userInfo.locale) }}</span>
            </span>
          </p>
        </div>
        <!-- <div class="column is-narrow pl-0">
          <button class="button tooltip is-success"
            data-tooltip="Add Selected to Batch"
            :disabled="!inProgressQuotes.length"
            @click="addRangeToBatch(tableType.INPROGRESS)">
            <span class="icon">
              <i class="mdi mdi-plus  mdi-24px" />
            </span>
          </button>
        </div> -->
        <div class="column is-narrow">
          <div class="field is-narrow has-addons">
            <div class="control has-icons-left">
              <input class="input"
                v-model="inProgressQuotesQuery"
                type="text"
                placeholder="Quote No. or Rego">
              <span class="icon is-left">
                <i class="mdi mdi-magnify mdi-24px" />
              </span>
            </div>
            <div class="control">
              <a class="button is-primary is-outlined tooltip"
                data-tooltip="Reset search"
                @click="inProgressQuotesQuery = ''">
                <span class="icon">
                  <i class="mdi mdi-close mdi-24px" />
                </span>
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="column is-narrow pl-0">
          <button class="button tooltip is-success"
            data-tooltip="Download Excel"
            :disabled="!inProgressQuotes.length"
            @click="exportToExcel(tableType.INPROGRESS)">
            <span class="icon">
              <i class="mdi mdi-file-download-outline  mdi-24px" />
            </span>
          </button>
        </div> -->
      </div>
      <div class="field">
        <div class="table-container">
          <bulma-table class="table is-striped is-narrow is-fullwidth"
            ref="inProgressQuotesTable"
            :columns="batchingQuoteColumns"
            :page-index="inProgressQuotesFilter.pageIndex"
            :page-size="inProgressQuotesFilter.pageSize"
            :total-rows="inProgressQuotesTotalRows"
            :is-loading="isInProgressQuotesTableLoading"
            :sort-column="inProgressQuotesFilter.sortColumn"
            :sort-order="inProgressQuotesFilter.sortOrder"
            :draggable="false"
            :show-pagination="false"
            @sort="onInProgressQuotesSort"
            :is-title-checkable="false"
            :title-checkbox-location="'front'"
            @title-checkbox-changed="inProgressCheckboxChanged">
            <tr v-for="(quote, index) in filteredInProgressQuotes"
              :key="quote.quoteId"
              @click="highlightSelectedAvailableQuote(index, $event)"
              :class="{ 'highlight-red': isRowHighlighted(quote) }">
              <!-- <td class="has-vertical-middle has-text-centered">
              <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                <input v-model="quote.isChecked"
                  @change="handleInProgressCheckboxChange"
                  type="checkbox">
                <div class="state p-info">
                  <i class="icon mdi mdi-check" />
                  <label />
                </div>
              </div>
            </td> -->
              <td>
                <a href="#"
                  @click="viewQuote(quote.quoteId)">{{ quote.quoteNoRef }}</a>
              </td>
              <td>{{ quote.quoteStatus }}</td>
              <td>{{ quote.jobStage }}</td>
              <td>{{ quote.quoteStatusText }}</td>
              <!-- <td class="has-vertical-middle has-text-centered">
                <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                  <input v-model="quote.hasSeverity"
                    :disabled="true"
                    type="checkbox">
                  <div class="state p-info">
                    <i class="icon mdi mdi-check" />
                    <label />
                  </div>
                </div>
              </td>
              <td class="has-text-right">{{ quote.jobStart | formatDateLocale($userInfo.locale) }}</td> -->
              <td class="has-text-right">{{ quote.jobEnd | formatDateLocale($userInfo.locale) }}</td>
              <td class="has-text-centered">{{ quote.daysElapsed }}</td>
              <td>{{ quote.claimNo }}</td>
              <td>{{ quote.rego }}</td>
              <td>{{ quote.fullName }}</td>
              <td>{{ quote.insurer }}</td>
              <td class="has-text-right">{{ quote.excess | formatCurrency($userInfo.locale) }}</td>

              <td class="has-text-right">{{ quote.labourHour | formatNumberWithRounding($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.rate | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.labourTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.partTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.subletTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.miscTotal | formatCurrency($userInfo.locale) }}</td>
              <!-- <td>{{ quote.insurer }}</td> -->
              <!-- <td class="has-text-right">{{ quote.totalNotInvoiced | formatCurrency($userInfo.locale) }}</td> -->
              <!-- <td class="has-text-right">{{ quote.debtorInvoice | formatCurrency($userInfo.locale) }}</td> -->
              <td class="has-text-right">{{ quote.totalExGST | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right"
                :class="{ 'has-text-danger': delta(quote) < 0, 'has-text-success': delta(quote) >= 0 }">{{ delta(quote) | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-centered col-1">
                <a @mouseover="getNotesContent(quote.isNoteExists, quote.quoteId)"
                  @mouseout="resetNotesContent()"
                  @click="notesClick(quote.quoteId, quote.quoteNoRef)"
                  class="button is-dark is-small is-inverted">
                  <span class="icon is-medium"
                    v-tippy="{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }"
                    :content="notesContent">
                    <i class="mdi mdi-24px"
                      :class="[quote.isNoteExists ? 'mdi-note-edit has-text-warning': 'mdi-note-edit-outline has-text-grey']" />
                  </span>
                </a>
              </td>
              <!-- <td class="has-text-centered">
              <span class="icon"
                :class="[ quote.inScope ? 'has-text-success' : 'has-text-danger' ]">
                <i class="mdi mdi-24px"
                  :class="[ quote.inScope ? 'mdi-check' : 'mdi-close' ]" />
              </span>
            </td> -->
              <!-- <td class="has-vertical-middle has-text-centered is-content-width">
              <button class="button is-success is-small is-inverted tooltip is-tooltip-topright"
                @click="addToBatch(index, [quote])"
                data-tooltip="Add to batch">
                <span class="icon is-medium">
                  <i class="mdi mdi-plus mdi-24px" />
                </span>
              </button>
            </td> -->
            </tr>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <span icon="icon is-large">
                    <i class="mdi mdi-48px mdi-emoticon-sad" />
                  </span>
                  <p>Nothing</p>
                </div>
              </section>
            </template>
          </bulma-table>
        </div>
      </div>
    </article>

    <article v-if="!isBatchCompleted"
      class="tile is-child box detail-page-tile">
      <div class="columns">
        <div class="column">
          <p class="title">
            <span class="section-heading">
              <span class="section-heading-color pr-1">Out of Scope</span>
              <span class="has-text-primary">({{ outScopeQuotesTotalRows }})</span>
            </span>
          </p>
        </div>
        <div class="column is-narrow">
          <div class="field is-narrow has-addons">
            <div class="control has-icons-left">
              <input class="input"
                v-model="outScopeQuotesQuery"
                type="text"
                placeholder="Quote No. or Rego">
              <span class="icon is-left">
                <i class="mdi mdi-magnify mdi-24px" />
              </span>
            </div>
            <div class="control">
              <a class="button is-primary is-outlined tooltip"
                data-tooltip="Reset search"
                @click="outScopeQuotesQuery = ''">
                <span class="icon">
                  <i class="mdi mdi-close mdi-24px" />
                </span>
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="column is-narrow pl-0">
          <button class="button tooltip is-success"
            data-tooltip="Download Excel"
            :disabled="!outScopeQuotes.length"
            @click="exportToExcel(tableType.OUTSCOPE)">
            <span class="icon">
              <i class="mdi mdi-file-download-outline  mdi-24px" />
            </span>
          </button>
        </div> -->
      </div>
      <div class="field">
        <div class="table-container">
          <bulma-table class="table is-striped is-narrow is-fullwidth"
            ref="outScopeQuotesTable"
            :columns="batchingQuoteColumns"
            :page-index="outScopeQuotesFilter.pageIndex"
            :page-size="outScopeQuotesFilter.pageSize"
            :total-rows="outScopeQuotesTotalRows"
            :is-loading="isOutScopeQuotesTableLoading"
            :sort-column="outScopeQuotesFilter.sortColumn"
            :sort-order="outScopeQuotesFilter.sortOrder"
            :draggable="false"
            :show-pagination="false"
            @sort="onOutScopeQuotesSort">
            <tr v-for="(quote, index) in filteredOutScopeQuotes"
              :key="quote.quoteId"
              @click="highlightSelectedAvailableQuote(index, $event)"
              :class="{ 'highlight-red': isRowHighlighted(quote) }">
              <td>
                <a href="#"
                  @click="viewQuote(quote.quoteId)">{{ quote.quoteNoRef }}</a>
              </td>
              <td>{{ quote.quoteStatus }}</td>
              <td>{{ quote.jobStage }}</td>
              <td>{{ quote.quoteStatusText }}</td>
              <!-- <td class="has-vertical-middle has-text-centered">
                <div class="pretty p-icon p-curve p-smooth m-0 p-bigger">
                  <input v-model="quote.hasSeverity"
                    :disabled="true"
                    type="checkbox">
                  <div class="state p-info">
                    <i class="icon mdi mdi-check" />
                    <label />
                  </div>
                </div>
              </td>
              <td class="has-text-right">{{ quote.jobStart | formatDateLocale($userInfo.locale) }}</td> -->
              <td class="has-text-right">{{ quote.jobEnd | formatDateLocale($userInfo.locale) }}</td>
              <td class="has-text-centered">{{ quote.daysElapsed }}</td>
              <td>{{ quote.claimNo }}</td>
              <td>{{ quote.rego }}</td>
              <td>{{ quote.fullName }}</td>
              <td>{{ quote.insurer }}</td>
              <td class="has-text-right">{{ quote.excess | formatCurrency($userInfo.locale) }}</td>

              <td class="has-text-right">{{ quote.labourHour | formatNumberWithRounding($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.rate | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.labourTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.partTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.subletTotal | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right">{{ quote.miscTotal | formatCurrency($userInfo.locale) }}</td>
              <!-- <td>{{ quote.insurer }}</td> -->
              <!-- <td class="has-text-right">{{ quote.totalNotInvoiced | formatCurrency($userInfo.locale) }}</td> -->
              <!-- <td class="has-text-right">{{ quote.debtorInvoice | formatCurrency($userInfo.locale) }}</td> -->
              <td class="has-text-right">{{ quote.totalExGST | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-right"
                :class="{ 'has-text-danger': delta(quote) < 0, 'has-text-success': delta(quote) >= 0 }">{{ delta(quote) | formatCurrency($userInfo.locale) }}</td>
              <td class="has-text-centered col-1">
                <a @mouseover="getNotesContent(quote.isNoteExists, quote.quoteId)"
                  @mouseout="resetNotesContent()"
                  @click="notesClick(quote.quoteId, quote.quoteNoRef)"
                  class="button is-dark is-small is-inverted">
                  <span class="icon is-medium"
                    v-tippy="{ enabled: showNoteContent, placement: 'left-start', arrow: false, allowHTML: true }"
                    :content="notesContent">
                    <i class="mdi mdi-24px"
                      :class="[quote.isNoteExists ? 'mdi-note-edit has-text-warning': 'mdi-note-edit-outline has-text-grey']" />
                  </span>
                </a>
              </td>
              <!-- <td class="has-text-centered">
              <span class="icon"
                :class="[ quote.inScope ? 'has-text-success' : 'has-text-danger' ]">
                <i class="mdi mdi-24px"
                  :class="[ quote.inScope ? 'mdi-check' : 'mdi-close' ]" />
              </span>
            </td> -->
              <!-- <td class="has-vertical-middle has-text-centered is-content-width">
              <button class="button is-success is-small is-inverted tooltip is-tooltip-topright"
                @click="addToBatch(index, quote)"
                data-tooltip="Add to batch">
                <span class="icon is-medium">
                  <i class="mdi mdi-plus mdi-24px" />
                </span>
              </button>
            </td> -->
            </tr>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <span icon="icon is-large">
                    <i class="mdi mdi-48px mdi-emoticon-sad" />
                  </span>
                  <p>Nothing</p>
                </div>
              </section>
            </template>
          </bulma-table>
        </div>
      </div>
    </article>

    <div ref="notesList"
      class="is-hidden">
      <ul style="list-style-type: disc; padding-left: 1rem;">
        <li v-for="(note, index) in notes"
          :key="index">
          <span class="is-size-6">{{ note.remarks }}</span>
          <div class="is-flex is-align-items-center is-size-7">
            <user-profile-icon v-if="note.firstName || note.displayName"
              :is-text-profile="true"
              :first-name="note.firstName"
              :last-name="note.lastName"
              :display-name="note.displayName"
              :width="20"
              :height="20"
              class="pr-1" />
            <span class="help is-italic has-text-grey">{{ $filters.formatDateTimeLocale(note.remarkDateTime, $userInfo.locale) }}</span>
          </div>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import { BatchingQuoteColumns } from './columns'
import OrmBatchingService from './OrmBatchingService'
import BulmaTable from '@/components/BulmaTable'
import { OrmQuoteStatusTypes, OrmBatchStatusType, EventHubTypes } from '@/enums'
import Guid from '@/components/Guid'
import _orderBy from 'lodash/orderBy'
import { DateTimeFiltersMixin, NumberFiltersMixin, TextFiltersMixin } from '@/components/mixins/filters'
import OrmBatchStatistics from './components/OrmBatchStatistics2'
import { roundAwayFromZero, roundUp } from '@/components/utils/AccountingFunctions'
import _cloneDeep from 'lodash/cloneDeep'
import RemarkService from '@/services/RemarkService'
import { RemarkTypes } from '@/enums'
import PrintPreviewService from '@/components/printpreview/PrintPreviewService'
import { KeyValuePairModel } from '@/classes/viewmodels'
import UserProfileIcon from '@/components/UserProfileIcon/UserProfileIcon'
import VueNumeric from '@/components/VueNumeric'

export default {
  name: 'OrmBatchingAvailableQuotes2',
  components: {
    BulmaTable,
    OrmBatchStatistics,
    UserProfileIcon,
    VueNumeric
  },
  filters: {},
  mixins: [DateTimeFiltersMixin, NumberFiltersMixin, TextFiltersMixin],
  props: {
    value: null,
    quotes: null,
    removedQuotes: null
  },
  data: () => {
    return {
      innerValue: null,

      batchedQuotesQuery: '',
      inScopeQuotesQuery: '',
      inProgressQuotesQuery: '',
      outScopeQuotesQuery: '',

      isBatchedQuotesTableLoading: false,
      isInScopeQuotesTableLoading: false,
      isInProgressQuotesTableLoading: false,
      isOutScopeQuotesTableLoading: false,

      batchedQuotesFilter: {
        sortColumn: BatchingQuoteColumns[0].name,
        sortOrder: BatchingQuoteColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 100
      },
      inScopeQuotesFilter: {
        sortColumn: BatchingQuoteColumns[0].name,
        sortOrder: BatchingQuoteColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 100
      },
      inProgressQuotesFilter: {
        sortColumn: BatchingQuoteColumns[0].name,
        sortOrder: BatchingQuoteColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 100
      },
      outScopeQuotesFilter: {
        sortColumn: BatchingQuoteColumns[0].name,
        sortOrder: BatchingQuoteColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 100
      },

      inRangeQuotes: [],
      batchedQuotes: [],
      inScopeQuotes: [],
      inProgressQuotes: [],
      outScopeQuotes: [],

      isNoteModalActive: false,
      notesContent: '',
      showNoteContent: false,
      notes: [],
      maxNotesShow: 3,
      remarkType: RemarkTypes.JcniNote,
      remarkDesc: 'Note',

      tableType: {
        INBATCH: 'In Batch',
        INSCOPE: 'In Scope',
        INPROGRESS: 'In Progress',
        OUTSCOPE: 'Out Scope'
      }
    }
  },
  computed: {
    permission() {
      return this.$user.permissions?.find((p) => p.codeName === 'A130') || {} //ORM Batching
    },
    isCanRead() {
      return this.permission && this.permission.hasRead
    },
    isCanAdd() {
      return this.permission && this.permission.hasAdd
    },
    isCanEdit() {
      return this.permission && this.permission.hasEdit
    },
    isCanPrint() {
      return this.permission && this.permission.hasPrint
    },
    isBatchCompleted() {
      const list = [this.ormBatchStatusType.Completed, this.ormBatchStatusType.Closed]
      return this.value && list.includes(this.value.batchStatus)
    },
    isBatchCanEdit() {
      return this.isCanEdit && !this.isBatchCompleted
    },
    guid() {
      return Guid
    },
    batchingQuoteColumns() {
      return BatchingQuoteColumns
    },
    alr() {
      if (this.combinedBatchedQuotes.length === 0) return 0
      // const batchAgreedTotal = this.batchedQuotes.length * this.innerValue.agreedArc
      // const batchNonLabourTotal = this.batchedQuotes.reduce(function (total, quote) {
      //   return roundAwayFromZero(total + quote.nonLabourTotal)
      // }, 0)
      const batchTotalLabourValue = this.combinedBatchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.labourTotal)
      }, 0)
      // const batchTotalLabourValue = batchAgreedTotal - batchNonLabourTotal
      const batchTotalLabourHour = this.combinedBatchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.labourHour)
      }, 0)
      if (!batchTotalLabourHour) return 0
      const avgLabourRate = roundUp(batchTotalLabourValue / batchTotalLabourHour, 1)
      return avgLabourRate
    },
    adjustedCombinedAlr() {

      if (this.combinedBatchedQuotes.length === 0) return 0
      const batchQuoteCount = this.combinedBatchedQuotes.length
      const agreedArc = this.innerValue.agreedArc
      // const batchAgreedTotal = batchQuoteCount * agreedArc
      const batchTotal = this.combinedBatchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.totalExGST)
      }, 0)
      const batchAvgJobCost = batchTotal / batchQuoteCount
      const batchAvgDiff = agreedArc - batchAvgJobCost
      const batchAvgAmountDiff = batchAvgDiff * batchQuoteCount
      const batchTotalLabourCost = this.combinedBatchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.labourTotal)
      }, 0)
      // const batchLabourTotal = batchAgreedTotal - batchNonLabourTotal
      const targetAdjustedLaboutCost = batchTotalLabourCost + batchAvgAmountDiff
      const batchTotalLabourHours = this.combinedBatchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.labourHour)
      }, 0)
      if (!batchTotalLabourHours) return 0
      const adjustedLabourRate = roundUp(targetAdjustedLaboutCost / batchTotalLabourHours, 1)
      return adjustedLabourRate
    },
    adjustedAlr() {

      if (this.batchedQuotes.length === 0) return 0
      const batchQuoteCount = this.batchedQuotes.length
      const agreedArc = this.innerValue.agreedArc
      // const batchAgreedTotal = batchQuoteCount * agreedArc
      const batchTotal = this.batchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.totalExGST)
      }, 0)
      const batchAvgJobCost = batchTotal / batchQuoteCount
      const batchAvgDiff = agreedArc - batchAvgJobCost
      const batchAvgAmountDiff = batchAvgDiff * batchQuoteCount
      const batchTotalLabourCost = this.batchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.labourTotal)
      }, 0)
      // const batchLabourTotal = batchAgreedTotal - batchNonLabourTotal
      const targetAdjustedLaboutCost = batchTotalLabourCost + batchAvgAmountDiff
      const batchTotalLabourHours = this.batchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.labourHour)
      }, 0)
      if (!batchTotalLabourHours) return 0
      const adjustedLabourRate = roundUp(targetAdjustedLaboutCost / batchTotalLabourHours, 1)
      return adjustedLabourRate
    },
    adjustedTotal() {
      if (this.combinedBatchedQuotes.length === 0) {
        return 0
      }
      const labourHourTotal = this.combinedBatchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.labourHour)
      }, 0)
      const nonLabourTotal = this.combinedBatchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.nonLabourTotal)
      }, 0)
      return roundAwayFromZero(nonLabourTotal + labourHourTotal * this.alr)
    },
    // averageLabourUnits() {
    //   if (this.batchedQuotes.length === 0) {
    //     return 0
    //   }
    //   const total = this.batchedQuotes.reduce(function (total, quote) {
    //     return roundAwayFromZero(total + quote.labourHour)
    //   }, 0)
    //   return roundAwayFromZero(total / this.batchedQuotes.length)
    // },
    // averageLabourValues() {
    //   if (this.batchedQuotes.length === 0) {
    //     return 0
    //   }
    //   const total = this.batchedQuotes.reduce(function (total, quote) {
    //     return roundAwayFromZero(total + quote.labourTotal)
    //   }, 0)
    //   return roundAwayFromZero(total / this.batchedQuotes.length)
    // },
    // averageNonLabourValues() {
    //   if (this.batchedQuotes.length === 0) {
    //     return 0
    //   }
    //   const total = this.batchedQuotes.reduce(function (total, quote) {
    //     return roundAwayFromZero(total + quote.nonLabourTotal)
    //   }, 0)
    //   return roundAwayFromZero(total / this.batchedQuotes.length)
    // },
    averageTotalExGst() {
      if (this.batchedQuotes.length === 0) {
        return 0
      }
      const total = this.batchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.totalExGst)
      }, 0)
      return roundAwayFromZero(total / this.batchedQuotes.length)
    },
    labourUnitTotal() {
      const total = this.batchedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + quote.labourUnit)
      }, 0)
      return total
    },

    filteredBatchedQuotes() {
      const batchedQuotes = this.batchedQuotes
      if (!batchedQuotes) {
        return null
      }
      this.toggleBatchedQuotesTableLoading(true)
      const query = this.batchedQuotesQuery.toLowerCase()
      let results = batchedQuotes
      if (this.batchedQuotesQuery) {
        results = batchedQuotes.filter((q) => q.quoteNoRef.toLowerCase().includes(query) || q.rego.toLowerCase().includes(query))
      }
      this.toggleBatchedQuotesTableLoading(false)
      return results
    },
    filteredInScopeQuotes() {
      const inScopeQuotes = this.inScopeQuotes
      if (!inScopeQuotes) {
        return null
      }
      this.toggleInScopeQuotesTableLoading(true)
      const query = this.inScopeQuotesQuery.toLowerCase()
      let results = inScopeQuotes
      if (this.inScopeQuotesQuery) {
        results = inScopeQuotes.filter((q) => q.quoteNoRef.toLowerCase().includes(query) || q.rego.toLowerCase().includes(query))
      }
      this.toggleInScopeQuotesTableLoading(false)
      return results
    },
    filteredInProgressQuotes() {
      const inProgressQuotes = this.inProgressQuotes
      if (!inProgressQuotes) {
        return null
      }
      this.toggleInProgressQuotesTableLoading(true)
      const query = this.inProgressQuotesQuery.toLowerCase()
      let results = inProgressQuotes
      if (this.inProgressQuotesQuery) {
        results = inProgressQuotes.filter((q) => q.quoteNoRef.toLowerCase().includes(query) || q.rego.toLowerCase().includes(query))
      }
      this.toggleInProgressQuotesTableLoading(false)
      return results
    },
    filteredOutScopeQuotes() {
      const outScopeQuotes = this.outScopeQuotes
      if (!outScopeQuotes) {
        return null
      }
      this.toggleOutScopeQuotesTableLoading(true)
      const query = this.outScopeQuotesQuery.toLowerCase()
      let results = outScopeQuotes
      if (this.outScopeQuotesQuery) {
        results = outScopeQuotes.filter((q) => q.quoteNoRef.toLowerCase().includes(query) || q.rego.toLowerCase().includes(query))
      }
      this.toggleOutScopeQuotesTableLoading(false)
      return results
    },
    inProgressQuotesAvgCost() {
      const total = this.filteredInProgressQuotes.reduce((acc, curr) => acc + curr.totalExGST, 0)
      return total / this.filteredBatchedQuotes.length
    },
    ormQuoteStatusTypes() {
      return OrmQuoteStatusTypes
    },
    ormBatchStatusType() {
      return OrmBatchStatusType
    },
    // innerPerQuoteTotalMin() {
    //   return (this.value.perQuoteTotalMin ?? 0.0).toLocaleString()
    // },
    // innerPerQuoteTotalMax() {
    //   return (this.value.perQuoteTotalMax ?? 0.0).toLocaleString()
    // },
    innerAlrLowerThreshold() {
      return (this.value.alrLowerThreshold ?? 0.0).toLocaleString()
    },
    innerAlrUpperThreshold() {
      return (this.value.alrUpperThreshold ?? 0.0).toLocaleString()
    },
    innerBatchId() {
      return this.value.batchId
    },
    batchedQuotesTotalRows() {
      return this.batchedQuotes.length
    },
    combinedBatchedQuotesTotalRows() {
      return this.combinedBatchedQuotes.length
    },
    combinedBatchedQuotes(){
      //combine this.batchedQuotes and this.inScopeQuotes with isChecked == true
      var combined = this.batchedQuotes.concat(this.inScopeQuotes.filter(q => q.isChecked))
      return combined
    },
    inScopeQuotesTotalRows() {
      return this.inScopeQuotes.length
    },
    inProgressQuotesTotalRows() {
      return this.inProgressQuotes.length
    },
    outScopeQuotesTotalRows() {
      return this.outScopeQuotes.length
    },
    minBatchSize() {
      return this.value.minBatchSize || 0
    },
    // batchedQuotes() {
    //   return this.inRangeQuotes.filter((i) => i.batchId == this.innerBatchId)
    // },
    // inScopeQuotes() {
    //   return this.inRangeQuotes.filter((i) => !i.batchId && i.inScope)
    // },
    // outScopeQuotes() {
    //   return this.inRangeQuotes.filter((i) => !i.batchId && !i.inScope)
    // },
    formatDateLocale(value, locale) {
      return this.$filter.customFormatDateLocale(value, locale, { year: 'numeric', month: '2-digit', day: '2-digit' })
    }
  },
  watch: {
    innerValue: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  created() {
    this.innerValue = _cloneDeep(this.value)
    // this.getActiveBatchIds()
    // this.getBatchQuoteAvailableSummaries()
    this.getQuotesInRange()
    this.$eventHub.$on(EventHubTypes.EntitySaved, () => {
      this.innerValue = _cloneDeep(this.value)
      this.getQuotesInRange()
    })
  },
  mounted() {},
  methods: {
    isRowHighlighted(quote) {
      const quoteAlr = this.calcAlr(quote)
      const isOutRange = quoteAlr < this.innerAlrLowerThreshold || quoteAlr > this.innerAlrUpperThreshold
      return isOutRange
    },
    calcAlr(quote) {
      const totalLabourHour = quote.labourHour
      const totalLabourValue = quote.labourTotal
      // const nonLabourTotal = quote.nonLabourTotal
      // const agreedTotal = this.innerValue.agreedArc
      // const totalLabourValue = agreedTotal - nonLabourTotal
      return totalLabourHour ? roundUp(totalLabourValue / totalLabourHour, 1) : 0
    },
    calcAdjustedAlr() {
      // const agreedTotal = this.innerValue.agreedArc
    },
    async exportToExcel(tableType) {
      let quotes = []

      if (tableType == this.tableType.INBATCH) {
        quotes = this.batchedQuotes
      }
      if (tableType == this.tableType.INSCOPE) {
        quotes = this.inScopeQuotes
      }
      if (tableType == this.tableType.INPROGRESS) {
        quotes = this.inProgressQuotes
      }
      if (tableType == this.tableType.OUTSCOPE) {
        quotes = this.outScopeQuotes
      }

      const totalLabourCost = quotes.reduce((sum, quote) => sum + quote.labourTotal, 0.0)
      const totalNonLabourCost = quotes.reduce((sum, quote) => sum + quote.nonLabourTotal, 0.0)
      const totalExGST = quotes.reduce((sum, quote) => sum + quote.totalExGST, 0.0)
      const totalLabourHour = quotes.reduce((sum, quote) => sum + quote.labourHour, 0.0)
      // const totalLabourRate = quotes.reduce((sum, quote) => sum + quote.rate, 0.0)

      const jobCount = quotes.length
      // const avgLabourHours = totalLabourHour / jobCount
      const avgLabourRate = totalLabourCost / totalLabourHour
      const avgLabourCost = totalLabourCost / jobCount
      const avgNonLabourCost = totalNonLabourCost / jobCount
      const avgTotal = totalExGST / jobCount
      const adjustedTotal = totalExGST - totalLabourCost + (totalLabourHour * this.adjustedAlr)

      let params = Object.assign({
        CompanyID: this.$userInfo.companyId,
        BatchID: this.innerValue.batchId,
        QuoteIds: quotes.map((q) => q.quoteId).join(','),

        BatchNo: this.innerValue.batchNo,
        JobCount: jobCount,
        // AvgLabourHours: avgLabourHours.toFixed(2),
        TargetARC: this.$filters.formatNumber(this.innerValue.agreedArc, this.$userInfo.locale),
        AvgLabourRate: this.$filters.formatNumberWithRoundUp(avgLabourRate, this.$userInfo.locale, 1),
        EstimatedAdjustedLabourRate: this.$filters.formatNumber(this.adjustedAlr, this.$userInfo.locale),
        AvgLabourCost: this.$filters.formatNumber(avgLabourCost, this.$userInfo.locale),
        AvgNonLabourCost: this.$filters.formatNumber(avgNonLabourCost, this.$userInfo.locale),
        ActualARC: this.$filters.formatNumber(avgTotal, this.$userInfo.locale),
        AdjustedTotal: this.$filters.formatNumber(adjustedTotal, this.$userInfo.locale)
      })
      const keyValuePairs = KeyValuePairModel.convertToKeyValuePairs(params)
      await PrintPreviewService.exportReportEx('rptOrmBatchQuotes', 'excel', keyValuePairs)
    },

    handleBatchedCheckboxChange(event) {
      const isChecked = event.target.checked
      if (!isChecked && this.$refs.batchedQuotesTable.isChecked) {
        this.$refs.batchedQuotesTable.uncheckWithoutReactive()
      }
    },
    handleInScopeCheckboxChange(event) {
      const isChecked = event.target.checked
      if (!isChecked && this.$refs.inScopeQuotesTable.isChecked) {
        this.$refs.inScopeQuotesTable.uncheckWithoutReactive()
      }
    },
    // handleInProgressCheckboxChange(event) {
    //   const isChecked = event.target.checked
    //   if (!isChecked && this.$refs.inProgressQuotesTable.isChecked) {
    //     this.$refs.inProgressQuotesTable.uncheckWithoutReactive()
    //   }
    // },

    batchedCheckboxChanged(value) {
      this.batchedQuotes = this.batchedQuotes.map((i) => ({ ...i, isChecked: !!value }))
    },
    inScopeCheckboxChanged(value) {
      this.inScopeQuotes = this.inScopeQuotes.map((i) => ({ ...i, isChecked: !!value }))
    },
    inProgressCheckboxChanged(value) {
      this.inProgressQuotes = this.inProgressQuotes.map((i) => ({ ...i, isChecked: !!value }))
    },
    outScopeCheckboxChanged(value) {
      this.outScopeQuotes = this.outScopeQuotes.map((i) => ({ ...i, isChecked: !!value }))
    },

    async getQuotesInRange() {
      const quotes = await OrmBatchingService.getOrmBatchingQuotesInRange(this.innerBatchId)
      this.inRangeQuotes = quotes
      this.reassignQuotes()
    },

    highlightSelectedAvailableQuote() {},

    onBatchedQuotesSort(name, order) {
      this.batchedQuotesFilter.sortColumn = name
      this.batchedQuotesFilter.sortOrder = order
      this.batchedQuotes = _orderBy(this.batchedQuotes, this.batchedQuotesFilter.sortColumn, this.batchedQuotesFilter.sortOrder)
    },
    onInProgressQuotesSort(name, order) {
      this.inProgressQuotesFilter.sortColumn = name
      this.inProgressQuotesFilter.sortOrder = order
      this.inProgressQuotes = _orderBy(this.inProgressQuotes, this.inProgressQuotesFilter.sortColumn, this.inProgressQuotesFilter.sortOrder)
    },
    onInScopeQuotesSort(name, order) {
      this.inScopeQuotesFilter.sortColumn = name
      this.inScopeQuotesFilter.sortOrder = order
      this.inScopeQuotes = _orderBy(this.inScopeQuotes, this.inScopeQuotesFilter.sortColumn, this.inScopeQuotesFilter.sortOrder)
    },
    onOutScopeQuotesSort(name, order) {
      this.outScopeQuotesFilter.sortColumn = name
      this.outScopeQuotesFilter.sortOrder = order
      this.outScopeQuotes = _orderBy(this.outScopeQuotes, this.outScopeQuotesFilter.sortColumn, this.outScopeQuotesFilter.sortOrder)
    },

    viewQuote(quoteId) {
      this.$emit('view-quote', quoteId)
    },

    // addToBatch(index, quote) {
    //   const existingIndex = this.innerValue.quoteIds
    //     .map((q) => {
    //       return q.quoteId
    //     })
    //     .indexOf(quote.quoteId)
    //   // console.log(existingIndex)
    //   if (existingIndex === -1) {
    //     this.innerValue.quoteIds.splice(this.innerValue.quoteIds.length, 1, {
    //       isDeleted: false,
    //       isDirty: false,
    //       isNew: true,
    //       quoteId: quote.quoteId,
    //       sourceBatchId: this.availableBatch ? this.availableBatch.batchId : Guid.empty()
    //     })
    //     quote.isNew = true
    //     if (this.availableBatch) {
    //       quote.sourceBatchId = this.availableBatch.batchId
    //     } else {
    //       quote.sourceBatchId = Guid.empty()
    //     }
    //   } else {
    //     const quoteId = this.innerValue.quoteIds[existingIndex]
    //     quoteId.destinationBatchId = Guid.empty()
    //     quoteId.isDeleted = false
    //   }
    //   const availableQuoteIndex = this.availableQuotes
    //     .map((q) => {
    //       return q.quoteId
    //     })
    //     .indexOf(quote.quoteId)
    //   this.availableQuotes.splice(availableQuoteIndex, 1)
    //   this.availableQuoteTotalRows = this.availableQuotes.length
    //   this.$emit('quote-added', quote)
    // },
    removeRangeToBatch() {
      const checkedBatchedQuotes = this.batchedQuotes.filter((i) => i.isChecked)
      this.removeFromBatch(0, checkedBatchedQuotes)
    },
    addRangeToBatch(tableType) {
      if (tableType == this.tableType.INSCOPE) {
        const checkedInScopeQuotes = this.inScopeQuotes.filter((i) => i.isChecked)
        this.addToBatch(0, checkedInScopeQuotes)
      }
      if (tableType == this.tableType.INPROGRESS) {
        const checkedInProgressQuotes = this.inProgressQuotes.filter((i) => i.isChecked)
        this.addToBatch(0, checkedInProgressQuotes)
      }
    },
    addToBatch(index, quotes) {
      let cnt = 0
      quotes.forEach((quote) => {
        const selectedQuote = this.inRangeQuotes.find((i) => i.quoteId == quote.quoteId)
        if (selectedQuote) {
          selectedQuote.batchId = this.innerValue.batchId
          selectedQuote.batchNo = this.innerValue.batchNo
          selectedQuote.isChecked = false

          const existingIndex = this.innerValue.quoteIds
            .map((q) => {
              return q.quoteId
            })
            .indexOf(quote.quoteId)
          // console.log(existingIndex)
          if (existingIndex === -1) {
            this.innerValue.quoteIds.splice(this.innerValue.quoteIds.length, 1, {
              isDeleted: false,
              isDirty: false,
              isNew: true,
              quoteId: quote.quoteId,
              sourceBatchId: Guid.empty()
            })
          } else {
            const quoteId = this.innerValue.quoteIds[existingIndex]
            quoteId.destinationBatchId = Guid.empty()
            quoteId.isDeleted = false
          }
          cnt++
        }
      })

      if (cnt > 0) {
        this.$notification.success('Add To Batch', `Added ${cnt} quotes to batch successfully.`)
        this.reassignQuotes()
      }
      // this.$emit('quote-added', quotes[0])
    },
    removeFromBatch(index, quotes) {
      let cnt = 0
      quotes.forEach((quote) => {
        const selectedQuote = this.inRangeQuotes.find((i) => i.quoteId == quote.quoteId)
        if (selectedQuote) {
          selectedQuote.batchId = null
          selectedQuote.batchNo = null
          selectedQuote.isChecked = false

          const existingIndex = this.innerValue.quoteIds.findIndex((q) => q.quoteId === quote.quoteId)

          if (existingIndex !== -1) {
            // Remove the quote from the array
            this.innerValue.quoteIds.splice(existingIndex, 1)
          }
          cnt++
        }
      })

      if (cnt > 0) {
        this.$notification.success('Remove From Batch', `Remove ${cnt} quotes from batch successfully.`)
        this.reassignQuotes()
      }
      // this.$emit('quote-removed', quotes[0])
    },
    reassignQuotes() {
      this.batchedQuotes = this.inRangeQuotes.filter((i) => i.batchId == this.innerBatchId)
      this.inScopeQuotes = this.inRangeQuotes.filter((i) => !i.batchId && i.inScope && i.quoteStatus == 'Completed')
      this.inProgressQuotes = this.inRangeQuotes.filter((i) => !i.batchId && i.inScope && i.quoteStatus == 'In Progress')
      this.outScopeQuotes = this.inRangeQuotes.filter((i) => !i.batchId && !i.inScope)
      if (!this.batchedQuotes.length) {
        if (this.$refs.batchedQuotesTable) {
          this.$refs.batchedQuotesTable.uncheckWithoutReactive()
        }
      }
      if (!this.inScopeQuotes.length) {
        if (this.$refs.inScopeQuotesTable) {
          this.$refs.inScopeQuotesTable.uncheckWithoutReactive()
        }
      }
      // if (!this.inProgressQuotes.length) {
      //   if (this.$refs.inProgressQuotesTable) {
      //     this.$refs.inProgressQuotesTable.uncheckWithoutReactive()
      //   }
      // }
    },

    toggleBatchedQuotesTableLoading(value) {
      this.isBatchedQuotesTableLoading = value
    },
    toggleInScopeQuotesTableLoading(value) {
      this.isInScopeQuotesTableLoading = value
    },
    toggleInProgressQuotesTableLoading(value) {
      this.isInProgressQuotesTableLoading = value
    },
    toggleOutScopeQuotesTableLoading(value) {
      this.isOutScopeQuotesTableLoading = value
    },

    async resetNotesContent() {
      this.showNoteContent = false
      this.notesContent = ''
      this.notes = []
    },
    async getNotesContent(isNoteExists, quoteId) {
      if (isNoteExists) {
        this.notesContent = ''
        this.showNoteContent = true
        this.notes = await RemarkService.getRemarkEntities(quoteId, RemarkTypes.JcniNote)
        this.notes = _orderBy(this.notes, 'createdDate', 'desc')
        this.notes = this.notes.splice(0, this.maxNotesShow)
        this.$nextTick(() => {
          this.notesContent = this.$refs['notesList'].innerHTML
        })
      } else {
        this.resetNotesContent()
      }
    },
    notesClick(quoteId, jobNo) {
      this.selectedQuoteId = quoteId
      this.selectedJobNo = jobNo
      this.isNoteModalActive = true
    },
    closeNoteModal(entity) {
      if (entity.length !== 0) {
        const index = this.jcniRecords.findIndex((i) => i.quoteId === this.selectedQuoteId)
        if (index !== -1) {
          this.jcniRecords[index].isNoteExists = true
          // this.jcniRecords[index].notes = entity
        }
      }
      this.isNoteModalActive = false
    },
    delta(quote) {
      return this.innerValue.agreedArc - quote.totalExGST
    }
  }
}
</script>

<style lang="scss" scoped>
.has-sticky-tile {
  position: sticky;
  top: 3.25rem;
  z-index: 31;
}
.highlight-red {
  background-color: #ffe6e6 !important; /* Light red */
  transition: background-color 0.3s ease;
}
table {
  font-size: 0.9rem; /* Adjust as needed */
}
.table-container {
  max-width: 96.5vw; //calc(100vh - 6.5rem - 2rem - 2rem); // 6.5rem=toolbars, 2rem=child tile padding, 2rem=parent tile padding
  overflow-x: auto;
  // border: 1px solid hsl(0, 0%, 86%);
}
.has-text-nowrap {
  white-space: nowrap;
}
.setting-page-tile input.custom-setting {
  min-width: 100px;
  max-width: 130px;
}
.section-heading {
  font-size: 1.25rem !important;
}
.section-heading-color {
  color: #222222 !important;
}
.button-add {
  color: #3291ef !important;
  border-color: #3291ef !important;
  background: #fff;
}
.button-remove {
  color: #d92550 !important;
  border-color: #d92550 !important;
  background: #fff;
}
.table-container .pretty {
  vertical-align: top;
}
</style>